import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Conversation(props) {
    return (
        <SvgIcon {...props}>
            <path fill="#D2A3DD" d="M35.1 35.8l20.2-1.5v-20c0-2.9-2.4-5.2-5.2-5.2H7.2C4.3 9.1 2 11.5 2 14.3v39.9c0 1.9 2.1 1.1 2.1 1.1l8.1-5.1h22.2l.7-14.4z" /><path fill="#855185" d="M90.4 24H27.9c-4.2 0-7.6 3.4-7.6 7.6v44.7c0 4.2 3.4 7.6 7.6 7.6h55.2L95 91.4s3.1 1.1 3.1-1.6v-13V31.6c-.1-4.2-3.5-7.6-7.7-7.6zM77 65.5H40c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7h37c1.5 0 2.7 1.2 2.7 2.7.1 1.5-1.2 2.7-2.7 2.7zm0-18H40c-1.5 0-2.7-1.2-2.7-2.7S38.5 42 40 42h37c1.5 0 2.7 1.2 2.7 2.7s-1.2 2.8-2.7 2.8z" />
        </SvgIcon>
    );
}

Conversation.defaultProps = {
    viewBox: '0 0 100 100'
};

export default Conversation;
